import App from './App.vue'
import { store } from './vuex/Store'
import Vue from 'vue'
import appConfig from './core/Config'

import './assets/css/fonts.css'

Vue.config.productionTip = false

if (process.env.VUE_APP_ENVIRONMENT == 'development') {
  window.appConfig = appConfig;
}

// This is for push notifications on mobile browsers.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js')
}

new Vue({
  store,
  render: h => h(App),
}).$mount('#app')
